import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (!dsn) {
  console.warn("[Sentry] VITE_SENTRY_DSN no está configurado — error tracking deshabilitado");
}

// Session Replay es pesado (carga ~50KB extra y graba la sesión); sólo en prod.
const integrations = import.meta.env.PROD
  ? [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]
  : [Sentry.browserTracingIntegration()];

Sentry.init({
  dsn,
  environment: import.meta.env.MODE,
  enabled: !!dsn,
  integrations,
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Exponer en window para testing desde consola
if (typeof window !== "undefined") {
  (window as unknown as Record<string, unknown>).Sentry = Sentry;
}

export { Sentry };
